import { axios, get, post, patch, put, isNullOrEmpty, alertvue, success, failed, errorvue } from '@/utils/util'

export default function extendUtilsToVue(app) {
   // app.provide('$axios', axios)
    //app.provide('$get', get);
    //app.provide('$post', post);
    //app.provide('$patch', patch); 
    //app.provide('$put', put);
 //   app.provide('$isNullOrEmpty', isNullOrEmpty);

    //app.provide('$alert', alertvue);
    //app.provide('$success', success);
    //app.provide('$failed', failed);
    //app.provide('$error', errorvue);

    app.config.errorHandler = (err) => {
        /* 处理错误 */
        console.log(err);
    }
}